var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnknownOpponentFullCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile my challenges"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card challenge",
    filter: "url(#filter0_d_447_120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile photo",
    clipPath: "url(#clip1_447_120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 23",
    d: "M19 54.6866C19 47.886 28.6259 34 40.5 34C52.3741 34 62 47.886 62 54.6866C62 61.4871 52.3741 67 40.5 67C28.6259 67 19 61.4871 19 54.6866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 39.5,
    cy: 23.5,
    r: 15.5,
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 134"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 49,
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 49,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#333333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "?",
    d: "M53.8027 63.0382V62.9579C53.8118 62.1058 53.9025 61.4277 54.0748 60.9235C54.2472 60.4194 54.4921 60.0112 54.8095 59.6989C55.127 59.3866 55.5079 59.0988 55.9524 58.8356C56.22 58.675 56.4603 58.4853 56.6735 58.2667C56.8866 58.0437 57.0544 57.7871 57.1769 57.4971C57.3039 57.2071 57.3673 56.8859 57.3673 56.5335C57.3673 56.0962 57.263 55.717 57.0544 55.3958C56.8458 55.0746 56.5669 54.827 56.2177 54.653C55.8685 54.479 55.4807 54.392 55.0544 54.392C54.6825 54.392 54.3243 54.4678 53.9796 54.6195C53.6349 54.7712 53.3469 55.0099 53.1156 55.3356C52.8844 55.6612 52.7506 56.0873 52.7143 56.6138H51C51.0363 55.8553 51.2358 55.2062 51.5986 54.6663C51.966 54.1265 52.449 53.7138 53.0476 53.4283C53.6508 53.1428 54.3197 53 55.0544 53C55.8526 53 56.5465 53.1562 57.1361 53.4685C57.7302 53.7808 58.1882 54.2091 58.5102 54.7533C58.8367 55.2976 59 55.9178 59 56.6138C59 57.1045 58.9229 57.5484 58.7687 57.9455C58.619 58.3426 58.4014 58.6973 58.1156 59.0096C57.8345 59.3219 57.4943 59.5985 57.0952 59.8394C56.6961 60.0848 56.3764 60.3435 56.1361 60.6157C55.8957 60.8834 55.7211 61.2024 55.6122 61.5727C55.5034 61.943 55.4444 62.4047 55.4354 62.9579V63.0382H53.8027ZM54.6735 67C54.3379 67 54.0499 66.8818 53.8095 66.6453C53.5692 66.4089 53.449 66.1256 53.449 65.7954C53.449 65.4653 53.5692 65.182 53.8095 64.9455C54.0499 64.7091 54.3379 64.5908 54.6735 64.5908C55.0091 64.5908 55.2971 64.7091 55.5374 64.9455C55.7778 65.182 55.898 65.4653 55.898 65.7954C55.898 66.014 55.8413 66.2148 55.7279 66.3977C55.619 66.5806 55.4717 66.7279 55.2857 66.8394C55.1043 66.9465 54.9002 67 54.6735 67Z",
    fill: "#333333"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_447_120",
    x: -239,
    y: -258,
    width: 398,
    height: 523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.823529 0 0 0 0 0.823529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_447_120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_447_120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_447_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnknownOpponentFullCard);
export default __webpack_public_path__ + "static/media/icon-unknown-opponent-full-card.3ada4a9cb69b5da29a115927e639727e.svg";
export { ForwardRef as ReactComponent };